export class SeoSettingsModel {
   Id: number;
   SeoDescription: string;
   SeoKeyword: string;
}

export class GetSeoProductItem {
   seoDescription: string;
   seoKeyword: string;
}